import { useTranslation } from 'react-i18next';
import limpiarHtml from '../Compartido/limpiarHtml.js';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';

const TextosSobreNosotros = ({ sobrenosotros, personas, ruta }) => {

    const { t } = useTranslation();

    const imagen = sobrenosotros.imagen_cabecera ? ruta + "/" + sobrenosotros.imagen_cabecera : null;

    return (
        <>
            <CabeceraPagina titulo={t("Sobre_Nosotros")} eyebrow={t("Empresa")} imagen={imagen} />

            <section className="bhe-prose" dangerouslySetInnerHTML={{ __html: limpiarHtml(sobrenosotros.ladesc) }}></section>

            {
                personas.length > 0 ?
                    <section className="bhe-equipo">
                        <div className="bhe-equipo__head">
                            <h2>{t("Equipo")}</h2>
                            <p>{t("Conozca a los artífices de esta iniciativa")}</p>
                        </div>
                        <div className="bhe-equipo__grid">
                            {personas.map((equipo, index) => (
                                <div className="bhe-equipo__item" key={index}>
                                    <article className="bhe-equipo__card">
                                        <div className="bhe-equipo__foto">
                                            <img
                                                src={equipo.imagen ? ruta + "/quienesSomos/" + equipo.id + "/" + equipo.imagen : '/images/web/bedloop-nofoto.png'}
                                                alt={equipo.nombre + " " + equipo.apellidos}
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="bhe-equipo__body">
                                            <h3 className="bhe-equipo__nombre">{equipo.nombre} {equipo.apellidos}</h3>
                                            <div className="bhe-equipo__texto" dangerouslySetInnerHTML={{ __html: limpiarHtml(equipo.ladesc) }}></div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    </section>
                    :
                    null
            }
        </>
    );
}


export default TextosSobreNosotros;
